import { Validators } from "@angular/forms";

export class CustomValidators{
    constrructor(){

    }
    name(){
        return [
            Validators.required,
            Validators.minLength(2),
            Validators.maxLength(32),
            Validators.pattern(/^(\b\w{1,12}\b[ \t\n\r,.!?;:/-]*)*$/)
          ]
    }
    email(){
        return [
            Validators.required,
            Validators.pattern(
              /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,10}|[0-9]{1,3})(\]?)$/i
            ),
            
          ]
    }
    phone(){
        return [
            Validators.pattern("^\\d{9}$"),
            Validators.minLength(8),
            Validators.maxLength(11),
        ]
    }
    mobileNumber(){
        return [
        Validators.required,
        Validators.pattern("^\\d{9,10}$"),
          ]
    }
    address(){
        return [ Validators.maxLength(256), Validators.pattern(/^(\b\w{1,12}\b[ \t\n\r,.!?;:/-]*)*$/)]
    }
    password(){
        return [
            Validators.required,
            // Validators.pattern('(?=\\D*\\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{8,30}')
            Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)
          ]
    }
    zipCode(){
        return [
            Validators.required,
            Validators.pattern("^\\d{4}$")
        ]
    }
    companyName(){
        return [
            Validators.required,
            Validators.pattern("^[A-Za-z0-9][A-Za-z0-9 '&.,()-]{0,254}[A-Za-z0-9)]$")
        ]
    }
    url(){
        return [
            
            Validators.pattern(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/)
        ]
    }
  buisnessRegistrationNumber() {
  return [
    Validators.pattern(/^[A-Za-z0-9/]{6,20}$/)
  ];
}

vatNumber() {
  return [
    Validators.pattern(/^[A-Za-z0-9/]{6,20}$/)
  ];
}

    walletAddress(){
        return [Validators.required, Validators.pattern("^0x[a-fA-F0-9]{40}$")]
    }
    amount(){
        return [Validators.required, Validators.pattern(/^(0|[1-9]\d*)(\.\d{1,18})?$/)]
    }
}